<template>
  <div id="delete">
    <div class="backdrop">
      <div class="img-container">
        <img src="../../assets/bg-intro.png" :style=setPos alt="">
      </div>
    </div>
    <comp-header
      :headerPosition="headerPos"
      :leftIcon="headerLeftIcon"
      :pageTitle="headerPageTitle"
      :leftClick="goPrevious"
    />
    <div class="done-wrapper">
      <div class="done-container">
        <h1 v-if="isNormalAccount" style="margin-top:0">{{ $t('acc.delete.title') }}</h1>
        <p v-if="isNormalAccount" v-html="$t('acc.delete.content')"></p>
        <form-input
          v-if="isNormalAccount"
          :inputType="typePW"
          :placeholderText="passwordHolder"
          @inputParent="value => { password = value }"
        />
        <form-button
          :btnName="buttonName"
          @parentCall="performDelete"
        />
        <p class="comment" v-html="$t('acc.delete.comment')"></p>
      </div>
    </div>
    <CompModal
      v-if="showModal"
      @confirm="showModal = !showModal"
    >
      <div slot="body">{{ modalBody }}</div>
    </CompModal>
    <comp-loading
      v-if="isLoading"
    ></comp-loading>
  </div>
</template>

<script>
/* global FB */
/* global Kakao */

import common from '@/utils/common';
import CompModal from '@/components/CompModal';
import CompLoading from '@/components/CompLoading';
import CompHeader from '@/components/CompHeader';
import FormInput from '@/components/FormInput';
import FormButton from '@/components/FormButton';
import LOGIN_TYPE from '@/constants/loginType';
import SOCIAL from '@/constants/social';
import { loadFbSdk } from '@/utils/social';
import md5 from 'md5';

export default {
  name: 'delete',
  mixins: [
    common,
  ],
  data() {
    return {
      headerPos: 'on-top',
      headerLeftIcon: 'fa-chevron-left',
      headerPageTitle: this.$i18n.t('acc.delete.header'),

      typePW: 'password',
      passwordHolder: this.$i18n.t('acc.delete.placeholder'),
      password: '',
      loginType: '',

      buttonName: this.$i18n.t('acc.delete.button'),
      showModal: false,

      modalBody: this.$i18n.t('acc.delete.modalBody'),

      isLoading: false,
      isNormalAccount: false,

      docHeight: window.innerHeight,
      docWidth: window.innerWidth,
    };
  },
  components: {
    CompModal,
    CompLoading,
    CompHeader,
    FormInput,
    FormButton,
  },
  computed: {
    setPos() {
      const docHeight = this.docHeight;
      const docWidth = this.docWidth;
      let marginValue = '';
      if (docHeight > docWidth) {
        const marginCal = (docHeight - docWidth) / 2;
        marginValue = `-${marginCal}px`;
        return {
          'margin-left': marginValue,
          width: 'auto',
          height: '100%',
        };
      }
      if (docHeight < docWidth) {
        const marginCal = (docWidth - docHeight) / 2;
        marginValue = `-${marginCal}px`;
        return {
          'margin-top': marginValue,
          width: '100%',
          height: 'auto',
        };
      }
      return {
        width: '100%',
        height: 'auto',
      };
    },
  },
  methods: {
    detectLoginType() {
      this.loginType = localStorage.getItem('loginType');

      switch (this.loginType) {
        case LOGIN_TYPE.NONE:
        case LOGIN_TYPE.EMAIL:
          this.isNormalAccount = true;
          break;
        default:
          this.isNormalAccount = false;
      }
    },
    performDelete() {
      this.isLoading = true;
      switch (this.loginType) {
        case LOGIN_TYPE.NONE:
        case LOGIN_TYPE.EMAIL:
          this.deleteUser();
          break;
        case LOGIN_TYPE.FACEBOOK:
          this.performFacebookLeave();
          break;
        case LOGIN_TYPE.KAKAO:
          this.performKakaoLeave();
          break;
        case LOGIN_TYPE.NAVER:
          this.performNaverLeave();
          break;
        default:
          this.deleteError();
      }
    },
    performFacebookLeave() {
      try {
        FB.getLoginStatus((response) => {
          const status = response.status;
          if (status === 'connected') {
            this.password = response.authResponse.userID;

            FB.api('/me/permissions', 'delete', (res) => {
              if (Object.prototype.hasOwnProperty.call(res, 'success')) {
                const result = res.success;
                if (result === true) {
                  this.deleteUser();
                } else {
                  this.deleteError();
                }
              } else {
                this.deleteError();
              }
            });
          } else {
            this.deleteError();
          }
        });
      } catch (exception) {
        if (exception instanceof ReferenceError) {
          loadFbSdk(SOCIAL.FACEBOOK_APP_ID, SOCIAL.FACEBOOK_API_VERSION)
            .then(() => this.performFacebookLeave());
        }
      }
    },
    performKakaoLeave() {
      const vm = this;

      if (typeof (Kakao.Link) === 'undefined') {
        this.initKakao();
      }

      Kakao.API.request({
        url: '/v2/user/me',
        success(resultMe) {
          if (Object.prototype.hasOwnProperty.call(resultMe, 'id')) {
            vm.password = resultMe.id.toString();

            Kakao.API.request({
              url: '/v1/user/unlink',
              success() {
                vm.deleteUser();
              },
              fail() {
                vm.deleteError();
              },
            });
          } else {
            vm.deleteError();
          }
        },
        fail() {
          vm.deleteError();
        },
      });
    },
    performNaverLeave() {
      const callbackURI = encodeURIComponent(`${process.env.NAVER_REDIREICT_URI}?tag=delete`);
      const state = md5('svtn_state');
      let url = 'https://nid.naver.com/oauth2.0/authorize?response_type=code';
      url += `&client_id=${SOCIAL.NAVER_CLIENT_ID}`;
      url += `&redirect_uri=${callbackURI}`;
      url += `&state=${state}`;
      window.open(url, '_self');
    },
    detectNaverParams() {
      const deleteFlag = this.$route.params.deleteFlag;
      if (deleteFlag == null) return;
      if (deleteFlag) {
        this.password = deleteFlag;
        this.deleteUser();
      } else {
        this.deleteError();
      }
    },
    deleteUser() {
      if (this.password) {
        const password = this.password;
        this.$store.dispatch('deleteUser', { password })
          .then(({ status, data }) => {
            this.isLoading = false;

            if (status === 200) {
              if (data.resultCode === '-4') {
                this.modalBody = '비밀번호가 틀렸습니다.';
                this.showModal = true;
              } else if (data.resultCode === '0') {
                this.$store.dispatch('logOut')
                  .then(() => this.$router.push('/acc/delete/done'));
              } else {
                this.deleteError();
              }
            } else {
              this.deleteError();
            }
          });
      } else {
        this.isLoading = false;
        this.modalBody = '비밀번호를 입력해주세요.';
        this.showModal = true;
      }
    },
    deleteError() {
      this.isLoading = false;
      this.modalBody = '오류가 발생하였습니다.';
      this.showModal = true;
    },
    handleResize() {
      this.docHeight = window.innerHeight;
      this.docWidth = window.innerWidth;
    },
    initKakao() {
      Kakao.init(SOCIAL.KAKAO_CLIENT_ID);
    },
  },
  mounted() {
    this.detectLoginType();
    this.detectNaverParams();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<style lang="scss" src="../../scss/acc-done.scss" scoped></style>



// WEBPACK FOOTER //
// src/views/acc/acc-delete.vue